export const sanitizeLanguageCode = (languageCode: string) => {
  return languageCode === 'pt-BR' ? 'pt' : languageCode;
};

export const mapLanguageCodeToLocalazyCode = (languageCode: string) => {
  return languageCode === 'pt' ? 'pt-BR' : languageCode;
};
